module.exports = __webpack_public_path__ + "static/media/5.406be2ea.png";